import React, { useEffect } from "react";
import Clock from "../Clock";

const Booking = () => {
  useEffect(() => {
    const src = "https://assets.calendly.com/assets/external/widget.js";

    // φορτώνουμε το script 1 φορά
    if (!document.querySelector(`script[src="${src}"]`)) {
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <section id="booking" className="booking-section">
      <h2>Κλείστε online ραντεβού</h2>
      <h3>Μόνο για online θεραπείες</h3>

      <div className="time-section">
        <p>Τρέχουσα ημερομηνία και ώρα:</p>
        <Clock />
      </div>

      {/* Calendly inline widget begin */}
      <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/sofiadavh/30min?hide_gdpr_banner=1&primary_color=7a7953"
        style={{ minWidth: 320, height: 700, marginTop: 20  }}
      />
      {/* Calendly inline widget end */}
    </section>
  );
};

export default Booking;
